import { Button } from "@biteship/atom";
import { useState } from "react";
import ServiceAccordion from "./ServiceAccordion";
import ModalServiceForm from "./ModalServiceForm";

/**
 * 
 * @param {Object} props
 * @param {string} props.openCourierId - open courier id
 * @param {import("@store/action/openCourier").OpenCourierService[]} props.services
 * @returns 
 */
export default function ServicesSection({ openCourierId, services }) {
  const [showAddModal, setShowAddModal] = useState(false);

  const handleUpdateService = () => {
    window.location.reload();
  }

  const handleDeleteService = () => {
    window.location.reload();
  }

  const handleAddService = () => {
    window.location.reload();
  }

  return (
    <div className="space-y-4 w-full mb-12">
      <h2 className="text-sm text-gray-900 font-semibold mb-0">Layanan Pengiriman Anda</h2>
      <p className="text-sm text-gray-700">Layanan Anda akan terdaftar pada <a className="text-primary hover:underline" href="https://biteship.com/id/docs/api/couriers/retrieve" target="_blank" rel="noopener noreferrer">Get Couriers API</a>.</p>
      {services.map((service, index) => (
        <ServiceAccordion
          key={service.id} 
          index={index}
          openCourierId={openCourierId}
          service={service} 
          onUpdateService={handleUpdateService}
          onDeleteService={handleDeleteService}
        />
      ))}
      
      <Button 
        title="Tambah Layanan" 
        className="md:w-auto" 
        onClick={() => setShowAddModal(true)}
      />

      <ModalServiceForm 
        show={showAddModal} 
        onClose={() => setShowAddModal(false)} 
        openCourierId={openCourierId} 
        onSuccess={handleAddService} 
      />
    </div>
  )
}